import accounting from 'accounting';

// TODO: Complete all available currency formats
const formats = {
    GBP: {
        symbol: '£',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    USD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    AUD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    CAD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    MXN: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    MAD: {
        symbol: 'د.م.‏',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v%s',
    },
    EUR: {
        symbol: '€',
        decimal: ',',
        thousand: ' ',
        precision: 2,
        format: '%v %s',
    },
    TRY: {
        symbol: '₺',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    AED: {
        symbol: 'د.إ',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v%s',
    },
    SEK: {
        symbol: 'kr',
        decimal: ',',
        thousand: '.',
        precision: 0,
        format: '%v %s',
    },
    ISK: {
        symbol: 'kr',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s',
    },
    JOD: {
        symbol: 'د.أ',
        decimal: '.',
        thousand: ',',
        precision: 3,
        format: '%v%s',
    },
    NZD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    ZAR: {
        symbol: 'R',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s %v',
    },
    PLN: {
        symbol: 'zl',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s %v',
    },
    ARS: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s %v',
    },
    MKD: {
        symbol: 'ден.',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v %s',
    },
    CHF: {
        symbol: '₣',
        decimal: '.',
        thousand: '\'',
        precision: 2,
        format: '%v %s',
    },
    OMR: {
        symbol: '﷼',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v %s',
    },
};

export default {
    methods: {
        formatMoney: function(number, currency = 'GBP') {
            return accounting.formatMoney(number, formats[currency]).replace(' ',' ');//add nbsp;
        },

        price(product) {
            return this.formatMoney(
                product.total_price,
                this.selectedCurrency.code
            );
        },

        priceWithPaymentType(totals, type = 'PP') {
            let price = totals.pay_online;

            if (type === 'POA') {
                price = totals.pay_on_arrival;
            }

            return this.formatMoney(
              price,
              this.selectedCurrency.code
            );
        },

        originalPrice(product) {
            return this.formatMoney(
                product.original_price,
                this.selectedCurrency.code
            );
        },

        originalPricePerDay(product, hire_days) {
            return this.formatMoney(
                (product.total_price / hire_days),
                this.selectedCurrency.code
            );
        },

        selectedPriceDiffBasePrice(selectedProduct, product, hire_days) {
            // Return ONLY the absolute difference in price, per day (ie, always a positive number)
            return this.formatMoney((Math.abs(product.total_price - selectedProduct.total_price) / hire_days), this.selectedCurrency.code);
        },

        insuranceDepositPrice(product, selectedVehicle = null, vehicle = null) {
            const activeVehicle = selectedVehicle?.data?.vehicle?.data?.charge_totals?.base_rental > 0
              ? selectedVehicle?.data?.vehicle?.data
              : vehicle;

            if (activeVehicle?.charge_totals?.base_rental) {
                return this.insuranceDepositFromVehicle(activeVehicle);
            } else {
                if (product?.insurance_deposit !== null && typeof product?.insurance_deposit !== 'undefined') {
                    return this.formatMoney(
                      product.insurance_deposit,
                      this.selectedCurrency.code
                    ).replace(/\.00$/gi, '');
                }
            }

            if (typeof selectedVehicle?.data?.vehicle?.data?.insurance_excess === 'undefined') {
                return this.insuranceDepositFromVehicle(vehicle);
            }

            if (selectedVehicle && product?.insurance_deposit === undefined) {
                // Set unlimited deposit if there is a selected vehicle and no product excess
                if (selectedVehicle.data.vehicle.data.insurance_deposit === null) {
                    return this.insuranceDepositFromVehicle(selectedVehicle.data.vehicle.data);
                }

                // Set defined deposit if there is a selected vehicle and no product excess
                return this.formatMoney(
                    selectedVehicle.data.vehicle.data.insurance_deposit,
                    this.selectedCurrency.code
                ).replace(/\.00$/gi, '');
            }

            if (product.insurance_deposit === null) {
                return this.insuranceDepositFromVehicle(vehicle);
            }

            return this.formatMoney(
                product.insurance_deposit,
                this.selectedCurrency.code
            ).replace(/\.00$/gi, '');
        },

        insuranceDepositFromVehicle(vehicle) {
            if (vehicle?.insurance_deposit !== null) {
                return this.formatMoney(
                  vehicle?.insurance_deposit,
                  this.selectedCurrency.code
                ).replace(/\.00$/gi, '');
            }

            return 'Unlimited';
        },

        insuranceExcessFromVehicleWithoutConversion(vehicle) {
            if (vehicle?.insurance_excess !== null) {
                return vehicle?.insurance_excess;
            }
            return 0;
        },

        insuranceExcessFromVehicle(vehicle) {
            if (vehicle?.insurance_excess !== null) {
                return this.formatMoney(
                  vehicle?.insurance_excess,
                  this.selectedCurrency.code
                ).replace(/\.00$/gi, '');
            }
            return 'Unlimited';
        },

        insuranceExcessPrice(product, selectedVehicle = null, vehicle = null) {
            const activeVehicle = selectedVehicle?.data?.vehicle?.data?.charge_totals?.base_rental > 0
                ? selectedVehicle?.data?.vehicle?.data
                : vehicle;

            if (activeVehicle?.charge_totals?.base_rental) {
                return this.insuranceExcessFromVehicle(activeVehicle);
            } else {
                if (product?.insurance_excess !== null && typeof product?.insurance_excess !== 'undefined') {
                    return this.formatMoney(
                      product.insurance_excess,
                      this.selectedCurrency.code
                    ).replace(/\.00$/gi, '');
                }
            }

            if (typeof selectedVehicle?.data?.vehicle?.data?.insurance_excess === 'undefined') {
                return this.insuranceExcessFromVehicle(vehicle);
            }

            if (selectedVehicle && product?.insurance_excess === undefined) {
                // Set unlimited excess if there is a selected vehicle and no product excess
                if (selectedVehicle.data.vehicle.data.insurance_excess === null) {
                    return this.insuranceExcessFromVehicle(selectedVehicle.data.vehicle.data);
                }

                // Set defined excess if there is a selected vehicle and no product excess
                return this.formatMoney(
                  selectedVehicle.data.vehicle.data.insurance_excess,
                  this.selectedCurrency.code
                ).replace(/\.00$/gi, '');
            }

            if (product?.insurance_excess === null) {
                return this.insuranceExcessFromVehicle(vehicle);
            }

            return this.formatMoney(
              product.insurance_excess,
              this.selectedCurrency.code
            ).replace(/\.00$/gi, '');
        },

    },
};
